import { render, staticRenderFns } from "./SedeSelector.vue?vue&type=template&id=58488156&scoped=true"
import script from "./SedeSelector.vue?vue&type=script&lang=js"
export * from "./SedeSelector.vue?vue&type=script&lang=js"
import style0 from "./SedeSelector.vue?vue&type=style&index=0&id=58488156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58488156",
  null
  
)

export default component.exports